exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-instruction {\n    width: 50%;\n    margin: auto;\n    display: block;\n    text-align: center;\n}\n.p {\n    margin: 0 0 1.5em;\n    padding: 0;\n}\n.blue-bg {\n    background: #4EB9FF !important;\n    text-align: left;\n    font-size: 18px;\n    color: #fff;\n    padding: 5px 10px !important;\n    display: block;\n    width: 100%;\n}\n.close {\n    background: transparent;\n    border: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    color: #000;\n}\n@media (max-width: 600px) {\n    .upload-instruction {\n        width: 100%;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/ink-color-picker/ink-color-picker.component.css
// module id = ../../../../../src/app/mnt-invoices/ink-color-picker/ink-color-picker.component.css
// module chunks = common